import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=b8be4f12&scoped=true&"
import script from "./CouponCard.vue?vue&type=script&lang=js&"
export * from "./CouponCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponCard.vue?vue&type=style&index=0&id=b8be4f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8be4f12",
  null
  
)

export default component.exports